import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AuditHistoryLayer from "../../../components/Admin/AuditHistoryLayer";

const AuditHistory = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Audit' />

                {/* BlankPageLayer */}
                <AuditHistoryLayer />
            </MasterLayout>
        </>
    );
};
export default AuditHistory;